import { Component, Inject, OnInit } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { Overlay } from '@angular/cdk/overlay';
import { Router } from '@angular/router';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { Direction } from '@angular/cdk/bidi';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Component({
    selector: 'app-special-messages-pop-up',
    templateUrl: './special-messages-pop-up.component.html',
    styleUrls: ['./special-messages-pop-up.component.scss'],
    standalone: false
})
export class SpecialMessagesPopUpComponent extends PopUpComponent implements OnInit {

  combinedMessages: SpecialMessage[]

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,

    @Inject(POPUP_DATA)
    public readonly data: { messages: SpecialMessage[] },
    private readonly languageService: LanguageService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  selectedMessage: SpecialMessage | null
  direction: Direction

  override ngOnInit(): void {
    super.ngOnInit()
    this.isDesktop = this.resizeService.isDesktop;
    this.initializeMultiLanguageTexts()
    const map = new Map();

    this.data.messages.forEach(item => {
        map.set(item.messageId, item); // Overwrites duplicates, keeping only one instance
    });

    this.combinedMessages = Array.from(map.values());
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
     this.direction = language.direction
    })
  }

  public onSelectSpecialMessage(specialMessage: SpecialMessage | null) {
    this.selectedMessage = specialMessage
  }
}
